export const util = {
  downloadDataUrlFromJavascript(filename, dataUrl) {
    // Construct the 'a' element
    var link = document.createElement("a");
    link.download = filename;
    link.target = "_blank";

    // Construct the URI
    link.href = dataUrl;
    document.body.appendChild(link);
    link.click();

    // Cleanup the DOM
    document.body.removeChild(link);
    //delete link;
  },
  httpGetData(dataUrl, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", dataUrl, true); // false for synchronous request
    xhr.responseType = "arraybuffer";
    xhr.onload = (e) => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          var data = new Uint8Array(xhr.response);
          callback(data);
        } else {
          console.error(xhr.statusText);
        }
      }
    };
    xhr.onerror = function(e) {
      console.error(xhr.statusText);
    };
    xhr.send();
  },
};
